export const addNewProjectConstants = {
    GET_SUCCESS: 'GET_NEW_PROJECT_SUCCESS',
    GET_FAILURE: 'GET_NEW_PROJECT_FAILURE',
};
